import { EAchievementsIntencity, EAchievementType, TGlobalAchievements } from './types';

export const CACHE_TIMEOUT_MS = 1000;

export const CelebrationTitles = {
  [EAchievementsIntencity.Good]: [
    'Achievements.Celebration.Titles.Good.1',
    'Achievements.Celebration.Titles.Good.2',
    'Achievements.Celebration.Titles.Good.3',
    'Achievements.Celebration.Titles.Good.4',
    'Achievements.Celebration.Titles.Good.5',
    'Achievements.Celebration.Titles.Good.6',
  ],
  [EAchievementsIntencity.Great]: [
    'Achievements.Celebration.Titles.Great.1',
    'Achievements.Celebration.Titles.Great.2',
    'Achievements.Celebration.Titles.Great.3',
    'Achievements.Celebration.Titles.Great.4',
    'Achievements.Celebration.Titles.Great.5',
    'Achievements.Celebration.Titles.Great.6',
  ],
  [EAchievementsIntencity.Outstanding]: [
    'Achievements.Celebration.Titles.Outstanding.1',
    'Achievements.Celebration.Titles.Outstanding.2',
    'Achievements.Celebration.Titles.Outstanding.3',
    'Achievements.Celebration.Titles.Outstanding.4',
    'Achievements.Celebration.Titles.Outstanding.5',
    'Achievements.Celebration.Titles.Outstanding.6',
  ],
};

export const CELEBRATION_LOTTIE_TIMEOUT_MS = 2000;
export const CELEBRATION_BADGE_TIMEOUT_MS = 2190;
export const CELEBRATION_ACHIEVEMENT_BADGE_TIMEOUT_MS = 700;
// we wait for 1000ms delay before the screen will be removed
export const CELEBRATION_ACHIEVEMENT_BADGES_WAITING_MS = 1000;

export const CELEBRATION_LOTTIES = ['Fireworks_Good', 'Fireworks_Great', 'Fireworks_Outstanding'];

// which performance counts as achievement
export const PERFORMANCE_ACHIEVEMENTS = [99, 95, 90, 80, 70, 60, 50, 40];
// which amount of gameplays counts as achievement
export const ACTIVITY_ACHIEVEMENTS = [1000, 500, 100, 50, 20, 10, 5, 1];
// tiers of workoutNumbers achievement
export const NUMBER_WORKOUTS = [200, 100, 50];
// tiers of playTimeLength achievement
export const HOURS_PLAY_TIME = [10, 5, 1];
// tiers of FinishedSessions achievement
export const NUMBER_SESSIONS = [100, 42, 21];
// tiers of goal reached times achievement
export const GOAL_REACHED_TIMES = [100, 50, 10];
// tiers of accuracy perfect aggregated achievement
export const ACC_PERFECT_AGG = [100, 50, 10];
// tiers of histogram 90 reached achievement
export const HISTOGRAM_90P = [20, 10, 5];
// tiers of histogram 50 reached achievement
export const HISTOGRAM_50P = [20, 10, 5];

export const GLOBAL_ACHIEVEMENTS_LIST: Array<TGlobalAchievements> = [
  EAchievementType.HistogramPercentage90p,
  EAchievementType.HistogramPercentage50p,
  EAchievementType.AccuracyPerfectAgg,
  EAchievementType.GoalReachedTimes,
  EAchievementType.FinishedSessions,
  EAchievementType.PlayTimeLength,
  EAchievementType.WorkoutNumber,
];

export const GLOBAL_ACHIEVEMENTS_SUBTYPES_MAP: { [key in TGlobalAchievements]: Array<number> } = {
  [EAchievementType.HistogramPercentage90p]: HISTOGRAM_90P,
  [EAchievementType.HistogramPercentage50p]: HISTOGRAM_50P,
  [EAchievementType.AccuracyPerfectAgg]: ACC_PERFECT_AGG,
  [EAchievementType.GoalReachedTimes]: GOAL_REACHED_TIMES,
  [EAchievementType.FinishedSessions]: NUMBER_SESSIONS,
  [EAchievementType.PlayTimeLength]: HOURS_PLAY_TIME,
  [EAchievementType.WorkoutNumber]: NUMBER_WORKOUTS,
};
